const ABSOLUTE_URL_PATTERN = /^https?:\/\//i;

export const isAbsoluteUrl = (url: string) => {
	return ABSOLUTE_URL_PATTERN.test(url);
};

export const joinBaseUrl = (baseUrl: string, path: string) => {
	if (!baseUrl || isAbsoluteUrl(path)) {
		return path;
	}

	const normalizedBaseUrl = baseUrl.replace(/\/$/, '');
	const normalizedPath = path.startsWith('/') ? path : `/${path}`;

	return `${normalizedBaseUrl}${normalizedPath}`;
};
